const classNames = (classes) => {
  const filteredClasses = Object.keys(classes).filter((k) => classes[k]);
  return filteredClasses.join(' ');
};

export default classNames;
